import React from "react";
import Helmet from "react-helmet";

/**
 * Kajabi's `/forms/:id/embed.js` uses `document.write(...)`, which is brittle
 * in SPAs and during hydration. Instead, we render the HTML form directly and
 * include Kajabi's embed CSS/JS assets.
 */
export default function KajabiSubscribeEmbed({
  buttonText = "Subscribe",
  emailPlaceholder = "Email",
  className = "",
}) {
  return (
    <div className={`kajabi-subscribe-embed ${className}`.trim()}>
      <Helmet>
        <link
          href="//fonts.googleapis.com/css?family=Open+Sans:400,700"
          rel="stylesheet"
          type="text/css"
        />
        <link
          rel="stylesheet"
          href="https://kajabi-app-assets.kajabi-cdn.com/assets/form_embed-16f7ab4b6a39a3561005e3bd414a039f7e8d7edd34dd2bd3a5117db001f47b8e.css"
          media="all"
        />
        <script src="https://kajabi-app-assets.kajabi-cdn.com/assets/form_embed-078db9fbd605f88cacf4be4e946422176a701acc2cd5302f65edd45a886797a1.js" />
      </Helmet>

      <div id="kajabi-form" className="kajabi-form--inline">
        <form
          data-parsley-validate="true"
          data-kjb-disable-on-submit="true"
          action="https://www.essentialist.dev/forms/2148069331/form_submissions"
          acceptCharset="UTF-8"
          method="post"
        >
          <input
            type="hidden"
            name="authenticity_token"
            value="PSCB+IncU4rpQi+ZzDODCGuzuhnIjN2/BR2crFlZvHB4Pp2DgG/9ubxAhqDOQZfgoS2DXoae9aQlRVQDl/iZHw=="
            autoComplete="off"
          />

          <style id="form-embed-style" type="text/css" />

          <div className="kajabi-form__content">
            <fieldset>
              <div className="email-field kajabi-form__form-item">
                <input
                  required
                  placeholder={emailPlaceholder}
                  type="email"
                  name="form_submission[email]"
                  id="form_submission_email"
                />
              </div>
              <button
                className="kajabi-form__btn kajabi-form__btn--block-mobile"
                type="submit"
              >
                {buttonText}
              </button>
            </fieldset>
          </div>
        </form>
      </div>
    </div>
  );
}

